import { useMutation } from "@tanstack/react-query";
import { login } from "../api/AUTH/auth";
import { useAuth } from "../context/AuthContext";

// Custom hook for user login
export const useLogin = () => {
  const { setIsLoggedIn, fetchUser } = useAuth();

  return useMutation({
    mutationFn: login,
    onSuccess: async () => {
      setIsLoggedIn(true);// Update auth state to logged in
      await fetchUser(); // Refetch current user data
    },

  });
};
